/* eslint-disable max-len */

const bookmarkConstants = {
    favoritesHeader: "Favorites",
    favoritesHeaderTooltip:
        "Click favorite to quickly revisit this search or profile. Or click the 'x' to remove this from your search history.",
    favoritesLoadingText: "Loading your favorites...",
    recentsHeader: "History",
    recentsHeaderTooltip:
        "Click to revisit this recent search quickly. Click the star icon to favorite this search or click the 'x' to delete from your search history.",
    recentsLoadingText: "Loading your recent searches and profiles...",

    unfavoriteIconTooltip: "Click to remove this search from your favorite searches",
    favoriteIconTooltip: "Click to save this search in your favorites",
    archiveIconTooltip: "Click to remove this search from your recent searches",
    noFavoriteActions:
        "Click the star icon in the search bar to save a search. After favoriting a search, you can see it here and quickly revisit that search.", // TODO
    noRecentActions:
        "Once you start making searches and visiting profiles around Quorum, your most recent searches and visited profiles will appear here.",

    noFavoriteSearchesMobile:
        "After favoriting a search on the Quorum website, you can see it here and quickly revisit that search.",
    noRecentSearchesMobile:
        "Once you start making searches around the Quorum website, your most recent searches will appear here.",
}

export default bookmarkConstants
